import React from 'react';
import {
  CircleStackIcon,
  ClipboardDocumentCheckIcon,
  InformationCircleIcon,
  RectangleStackIcon
} from '@heroicons/react/24/outline';

const EvidenceTab = () => (
  <div className="bg-white p-6 animate-in fade-in duration-300" id="evidence-tab-panel">
    <div className="space-y-6">
      <div>
        <h2 className="text-xl font-bold text-gray-900">Evidence workspace</h2>
        <p className="mt-2 max-w-3xl text-sm leading-6 text-gray-600">
          This workspace will support a future workflow to configure an evidence source, declare service scope, collect evidence and resolve consultant questions.
        </p>
      </div>

      <div className="grid gap-4 lg:grid-cols-3">
        <section aria-labelledby="evidence-source-heading" className="rounded-lg border border-gray-200 bg-gray-50 p-5">
          <div className="flex items-start gap-3">
            <CircleStackIcon aria-hidden="true" className="h-6 w-6 flex-none text-blue-700" />
            <div>
              <h3 id="evidence-source-heading" className="font-semibold text-gray-900">Evidence source</h3>
              <p className="mt-2 text-sm font-medium text-gray-700">No evidence source is configured</p>
              <p className="mt-2 text-sm leading-6 text-gray-600">
                A future source configuration can collect objective information for consultant review.
              </p>
            </div>
          </div>
        </section>

        <section aria-labelledby="declared-services-heading" className="rounded-lg border border-gray-200 bg-gray-50 p-5">
          <div className="flex items-start gap-3">
            <RectangleStackIcon aria-hidden="true" className="h-6 w-6 flex-none text-blue-700" />
            <div>
              <h3 id="declared-services-heading" className="font-semibold text-gray-900">Declared services</h3>
              <p className="mt-2 text-sm font-medium text-gray-700">No services have been declared</p>
              <p className="mt-2 text-sm leading-6 text-gray-600">
                A consultant will declare the organisation services in scope before any evidence is collected.
              </p>
            </div>
          </div>
        </section>

        <section aria-labelledby="consultant-review-heading" className="rounded-lg border border-gray-200 bg-gray-50 p-5">
          <div className="flex items-start gap-3">
            <ClipboardDocumentCheckIcon aria-hidden="true" className="h-6 w-6 flex-none text-blue-700" />
            <div>
              <h3 id="consultant-review-heading" className="font-semibold text-gray-900">Consultant review</h3>
              <p className="mt-2 text-sm font-medium text-gray-700">No consultant review items are available</p>
              <p className="mt-2 text-sm leading-6 text-gray-600">
                Questions will appear only after a future collection identifies information that needs consultant judgement.
              </p>
            </div>
          </div>
        </section>
      </div>

      <section aria-labelledby="service-examples-heading" className="rounded-lg border border-blue-100 bg-blue-50 p-5">
        <h3 id="service-examples-heading" className="font-semibold text-blue-950">Examples only</h3>
        <p className="mt-2 text-sm leading-6 text-blue-900">
          These service types are guidance for this control. They are not declared services or tenant evidence.
        </p>
        <ul className="mt-4 grid gap-2 text-sm text-blue-950 sm:grid-cols-2">
          <li>Staff portal</li>
          <li>VPN gateway</li>
          <li>Remote administration portal</li>
          <li>Organisation-operated webmail</li>
        </ul>
      </section>

      <div className="flex gap-3 rounded-lg border border-blue-300 bg-blue-50 p-4 text-sm leading-6 text-blue-950" role="note">
        <InformationCircleIcon aria-hidden="true" className="h-5 w-5 flex-none text-blue-700" />
        <p>Evidence supports assessment. It never sets Control Status.</p>
      </div>
    </div>
  </div>
);

export default EvidenceTab;
